import { Form, Input, Select, Space } from 'antd';
import { InputProps } from 'antd/lib/input';
import { useState } from 'react';
import { phoneNumberCountryType } from '../../../Interfaces/Declaration.Interface';
import { countries } from '../../../utils/countries';
import './form_input_phone.scss';

type AdInputForm2Props = {
  prevalue: phoneNumberCountryType;
  label: string;
  name: string;
  messageForRequired?: string;
  required?: boolean;
} & InputProps;

export const cleanPhone2 = (phone: string | undefined) => {
  return phone?.replace(/\+56/g, '');
};

const FormInputPhone2 = ({
  prevalue,
  label,
  name,
  messageForRequired = 'Debe ingresar número de teléfono móvil',
  required = true,
  className = '',
  ...rest
}: AdInputForm2Props) => {
  const [valuePhone, setValuePhone] = useState<phoneNumberCountryType>({ ...prevalue });

  const validatePhoneNumber = (rule: any, value: string, callback: Function) => {
    const phoneNumberRegex = /^(?=(?:[^\d]*\d){9})[0-9\-\\(\\) ]{1,16}$/;
    const validationRegex = phoneNumberRegex.test(value);

    if (!validationRegex) {
      callback('¡Por favor, introduce un número de teléfono móvil válido, debe tener al menos 9 dígitos numéricos');
    } else {
      callback();
    }
  };

  return (
    <Form.Item label={label}>
      <Space.Compact style={{ width: '100%' }}>
        <Form.Item name={[name, 'phone_code']} noStyle>
          <Select
            style={{ height: '40px', width: '30%' }}
            value={valuePhone.phone_code}
            defaultValue={'+56'}
            showSearch
            onChange={(e) => setValuePhone({ ...valuePhone, phone_code: `${e}` })}
          >
            {countries.map((item) => (
              <option key={item.phone_code} value={item.phone_code}>
                {item.flag} {item.phone_code}
              </option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={[name, 'stringValue']}
          noStyle
          rules={[
            required || valuePhone.stringValue.length > 0
              ? {
                  validator: validatePhoneNumber,
                }
              : {},
            required || valuePhone.stringValue.length > 0
              ? {
                  required: true,
                  message: `${messageForRequired}`,
                }
              : {},
          ]}
        >
          <Input
            value={valuePhone.stringValue}
            defaultValue={prevalue.stringValue}
            className={`${className} phone`}
            style={{ width: '70%' }}
            {...rest}
            placeholder="226934277"
            onChange={(e) => setValuePhone({ ...valuePhone, stringValue: e.target.value })}
            maxLength={16}
          />
        </Form.Item>
      </Space.Compact>
    </Form.Item>
  );
};

export default FormInputPhone2;
